import { Injectable, Injector, Inject } from "@angular/core";
import { HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { UserProfile } from "../models";
import { ConfigService } from './config.service';
import { TokenService } from './token.service';
import { LoginService } from './login.service';
import { LogoutService } from './logout.service';
import { LoginResult } from "digital-core";

@Injectable()
export class AuthenticationService {
  loginResult: LoginResult;
  userProfile: UserProfile;
  webApiUrl: string;

  httpOptions = {
    headers: new HttpHeaders({
      Accept: "application/json"
      // Authorization: "my-auth-token"
    })
  };

  constructor(
    private injector: Injector,
    private configService: ConfigService,
    private dialogRef: MatDialog,
    private tokenService: TokenService,
    private logoutService: LogoutService
    //  private authorizationService: AuthorizationService,
  ) {
    this.webApiUrl = configService.apiUrl;
  }

  public get router(): Router {
    return this.injector.get(Router);
  }

  logOut(forceCacheClear: boolean) {
    const currentLoginInfo = this.tokenService.getCurrentUserInfo();
    const token = this.tokenService.getAccessToken();
    if (currentLoginInfo && token) {
      this.logoutService.logout(currentLoginInfo.Email, forceCacheClear).subscribe(data => {
        localStorage.removeItem("login_info");
        localStorage.removeItem("dealerShip_info");
        localStorage.removeItem("local_resources_menu_Portal_Left_Menu");
        localStorage.removeItem("token_info");
        localStorage.removeItem("branch_Info");
        this.loginResult = null;
        this.dialogRef.closeAll();
        let loginService = this.injector.get(LoginService);
        loginService.signOut();
      }, (error => {
        localStorage.removeItem("login_info");
        localStorage.removeItem("dealerShip_info");
        localStorage.removeItem("local_resources_menu_Portal_Left_Menu");
        localStorage.removeItem("token_info");
        this.loginResult = null;
        this.dialogRef.closeAll();
        let loginService = this.injector.get(LoginService);
        loginService.signOut();
      }));
    } else {
      localStorage.removeItem("login_info");
      localStorage.removeItem("dealerShip_info");
      localStorage.removeItem("local_resources_menu_Portal_Left_Menu");
      localStorage.removeItem("token_info");
      localStorage.removeItem("branch_Info");
      this.loginResult = null;
      this.dialogRef.closeAll();
      let loginService = this.injector.get(LoginService);
      loginService.signOut();
    }


  }

  //AUL Integration
  AulLogOut() {
    this.logOut(true);
  }

  //AUL integration
  addProfile(queryString: any) {
    let loginService = this.injector.get(LoginService);
    loginService.AULAddProfile(queryString);
  }

  isAuthenticated() {
    if (this.configService.bypassLogin) {
      return true;
    }
    const currentLoginInfo = this.tokenService.getCurrentUserInfo();
    const currentToken = this.tokenService.getCurrentAccessToken();

    if (!currentLoginInfo) {
      this.logOut(false);
      return false;
    }
    const now = new Date();
    const expirationDate = new Date(currentLoginInfo.ExpiresAt);

    return currentLoginInfo && currentToken && expirationDate > now;
  }


  existUserProfile() {
    const currentLoginInfo = this.tokenService.getCurrentUserInfo();
    if (!currentLoginInfo) {
      return false;
    }
    return true;
  }
}
